require.register("user/controllers/indexCtrl", function(exports, require, module){
  $0
  
});

